import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const inNewsValidation = () => {
    return yup.object().shape({
        title: yup.string().required(ERRORS.required),
        url: yup.string().url().required(ERRORS.required),
    });
};
